import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useUserPermission = value => {
  const claims = useSelector(state => state.user?.claims || []);

  const availableClaims = useMemo(() => {
    return claims.filter(claim => claim?.value).map(claim => claim.key);
  }, [claims]);

  return availableClaims.includes(value);
};

export default useUserPermission;
